import * as ParsedCode from "./parsedCode";

export const getCodeForLanguage = (language: string): string[] => {
  return ParsedCode[language];
};
